import enMessagesRaw from '../locales/en_US.extracted.json';

// Transform { id: { message: "..." } } to { id: "..." }
const enMessages = Object.keys(enMessagesRaw).reduce((acc, key) => {
  acc[key] = (enMessagesRaw as any)[key].message;
  return acc;
}, {} as Record<string, string>);

const EnLang = {
  messages: enMessages,
  locale: 'en-US',
};

export default EnLang;
